export const landing3Routes = [
  {
    path: '/landing3',
    lazy: async () => {
      const { LandingRoute } =
        await import('../Landing/LandingRoute/LandingRoute');
      return { Component: LandingRoute };
    },
  },
  {
    path: '/landing3/login',
    lazy: async () => {
      const { LoginRoute } = await import('./Login/Login');
      return { Component: LoginRoute };
    },
  },
  {
    path: '/landing3/register',
    lazy: async () => {
      const { RegisterRoute } = await import('./Register/Register');
      return { Component: RegisterRoute };
    },
  },
  {
    path: '/landing3/forgot-password',
    lazy: async () => {
      const { ForgotPasswordRoute } =
        await import('./ForgotPassword/ForgotPassword');
      return { Component: ForgotPasswordRoute };
    },
  },
  {
    path: '/landing3/search',
    lazy: async () => {
      const { SearchRoute } = await import('./Search/Search');
      return { Component: SearchRoute };
    },
  },
];

export const protectedLanding3Routes = [
  {
    path: '/landing3',
    lazy: async () => {
      const { LandingRoute } =
        await import('../Landing/LandingRoute/LandingRoute');
      return { Component: LandingRoute };
    },
  },
  {
    path: '/landing3/plan',
    lazy: async () => {
      const { PlanRoute } = await import('./Plan/Plan');
      return { Component: PlanRoute };
    },
  },
];
